import {RailsPartial} from '@github-ui/rails-partial'
import {pullRequestsChecksRoute} from './checks-route'
import styles from './Checks.module.css'
import {clsx} from 'clsx'
import {isModernPullRequestExperienceEnabled} from '@github-ui/pull-request-feature-flags'

export function ChecksEntrypoint() {
  const updatedHeader = isModernPullRequestExperienceEnabled()
  return (
    <div className={clsx(styles.checksRoot, updatedHeader && styles.constrainedContent, updatedHeader && 'tmp-pb-3')}>
      <RailsPartial partialName="Main" route={pullRequestsChecksRoute} />
    </div>
  )
}
